import type { EntityCollection } from "@firecms/core";
import type {
  ContentImportItemDto,
  ContentImportResult,
} from "../types";

export const LEARNING_PATH_KIND = "learningPath" as const;
export const LEARNING_PATH_VERSION = 1 as const;

export type LearningPathSpaceDto = {
  name: string;
  title: Record<string, string>;
  body: Record<string, string>;
};

export type NestedUnitDto = ContentImportItemDto & {
  stories?: unknown;
  questions?: unknown;
  levels?: unknown;
};

export type LearningPathBundle = {
  version: typeof LEARNING_PATH_VERSION;
  kind: typeof LEARNING_PATH_KIND;
  space: LearningPathSpaceDto;
  units: NestedUnitDto[];
};

export type FlattenedLearningPath = {
  space: LearningPathSpaceDto;
  units: ContentImportItemDto[];
  stories: ContentImportItemDto[];
  questions: ContentImportItemDto[];
  levels: ContentImportItemDto[];
};

export type LearningPathGraphIssue = {
  path: string;
  reason: string;
};

export type LearningPathContentCollections = {
  units: EntityCollection;
  stories: EntityCollection;
  questions: EntityCollection;
  levels: EntityCollection;
};

export type LearningPathImportSuccess = {
  spaceId: string;
  created: boolean;
  units: ContentImportResult;
  stories: ContentImportResult;
  questions: ContentImportResult;
  levels: ContentImportResult;
};

